var exports = {
  "l": "IssueBodyLoadingContainer__4shxPp",
};

module.exports = exports;
